























import Vue from "vue";
import Component from "vue-class-component";
import { LocaleSelectorType } from "@/store/i18n.store.module";
import { i18nModule, i18nState } from "@/utils/store-acessor";

@Component({})
export default class LocaleSelector extends Vue {
  @i18nModule.Getter("locales") locales!: LocaleSelectorType[];
  @i18nModule.Getter("locale") selected!: LocaleSelectorType;

  locale: LocaleSelectorType = { value: "en", text: "English", flag: require("@/assets/images/flags/en.png") };

  mounted() {
    if (this.selected.value === "en") {
      this.locale = { value: "en", text: "EN", flag: require("@/assets/images/flags/en.png") };
    } else {
      this.locale = { value: "ptBr", text: "PT-BR", flag: require("@/assets/images/flags/ptBr.png") };
    }
  }

  onLocaleChange(newValue: LocaleSelectorType) {
    i18nState.onChangeLocale(newValue);
    this.$i18n.locale = newValue.value;
    localStorage.setItem("defaultLocale", newValue.value);
  }
}
